"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _uiUtils = require("@airasia/ui-utils");

var _DefaultConfig = _interopRequireDefault(require("../../config/DefaultConfig"));

var _stateVariables = _interopRequireDefault(require("../../config/stateVariables"));

var _EnvironmentUrl = _interopRequireDefault(require("../../config/environment/EnvironmentUrl"));

var _AaHelpers = require("../../utils/AaHelpers");

var _AaHooks = require("../../utils/AaHooks");

var _AaSuggestionsRequestParams = require("../../utils/AaSuggestionsRequestParams");

var _AaSearchWidget = require("./models/AaSearchWidget.model");

var _SearchForm = _interopRequireDefault(require("./SearchForm"));

var _SearchAgain = _interopRequireDefault(require("./SearchAgain.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var parseDestination = function parseDestination(destination) {
  return {
    id: destination.id,
    name: destination.name,
    full_name: destination.full_name,
    type: destination.type
  };
};

var SearchWidget = function SearchWidget(props) {
  var _props$sharedLabel;

  var sharedComponentLabel = (0, _AaHooks.useAsyncData)(props.sharedLabel, undefined, _DefaultConfig["default"]);
  var _props$controls$preFi = props.controls.preFill,
      preFill = _props$controls$preFi === void 0 ? {} : _props$controls$preFi;
  var needsDestinationFetch = typeof preFill.destination === 'string';
  var destination = (0, _AaHooks.useAsyncData)(props.destination, parseDestination, null);
  var destinationToPrefill = needsDestinationFetch ? destination : preFill.destination;

  var fetchSuggestion = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var locale, suggestionParamsBuilder, suggestionUrl, headers;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!needsDestinationFetch) {
                _context.next = 8;
                break;
              }

              locale = props.controls.locale;
              suggestionParamsBuilder = (0, _AaSuggestionsRequestParams.getParamsBuilder)();
              suggestionUrl = suggestionParamsBuilder.getSuggestionUrl(preFill.destination, locale);
              _context.next = 6;
              return suggestionParamsBuilder.buildHeaders();

            case 6:
              headers = _context.sent;
              props.make_async_get_call(suggestionUrl, headers, _stateVariables["default"].suggestion);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchSuggestion() {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    var locale = props.controls.locale;
    var environmentUrls = _EnvironmentUrl["default"][props.controls.environment];
    var localeUrl = (0, _AaHelpers.format)(environmentUrls.SHARED_COMPONENT, [locale]);
    props.make_async_get_call(localeUrl, null, _stateVariables["default"].shared_component, false);
  }, [props.controls.locale]);
  (0, _react.useEffect)(function () {
    fetchSuggestion();
  }, [props.controls.locale, preFill.destination]);
  var desktopTabLayout = props.layout > _crossPlatformComponents.LAYOUT.mobile;
  var canPaintSearchForm = [props.layoutReady, !((_props$sharedLabel = props.sharedLabel) !== null && _props$sharedLabel !== void 0 && _props$sharedLabel.isFetching)].every(Boolean);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isFormFocused = _useState2[0],
      setIsFormFocused = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: [styles.form, desktopTabLayout && styles.desktopLayout, props.controls.isSearchAgain && _SearchAgain["default"].form, props.controls.isSearchAgain && isFormFocused && _SearchAgain["default"].focusedForm]
  }, canPaintSearchForm && /*#__PURE__*/_react["default"].createElement(_SearchForm["default"], {
    controls: {
      preFill: _objectSpread(_objectSpread({}, preFill), {}, {
        destination: destinationToPrefill
      }),
      environment: props.controls.environment,
      locale: props.controls.locale,
      currency: props.controls.currency,
      componentLabels: sharedComponentLabel,
      token: props.controls.token,
      is_login: props.controls.is_login,
      agentId: props.controls.agentId,
      forceMobileView: props.controls.forceMobileView,
      isSearchAgain: props.controls.isSearchAgain,
      searchHandler: props.controls.searchHandler,
      chinaDisclaimerService: props.controls.chinaDisclaimerService,
      closeSearchWidget: props.controls.closeSearchWidget,
      isCalendarOpenedByDeepLink: props.controls.isCalendarOpenedByDeepLink
    },
    navigation: props.navigation,
    onFormFocused: setIsFormFocused
  }));
};

var styles = _crossPlatformComponents.StyleSheet.create({
  form: {
    flex: 1,
    backgroundColor: '#fff',
    width: '100%',
    flexDirection: 'column',
    web: {
      borderRadius: 4
    }
  },
  desktopLayout: {
    paddingVertical: 10,
    paddingHorizontal: 15
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    sharedLabel: state.asyncAction[_stateVariables["default"].shared_component],
    destination: state.asyncAction[_stateVariables["default"].suggestion]
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  make_async_get_call: _uiUtils.make_async_get_call
})((0, _crossPlatformComponents.withLayoutContext)(SearchWidget));

exports["default"] = _default;